(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.current = 0;
      this.abortController = new AbortController();

      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.show(this.current - 1), {
        signal: this.abortController.signal,
      });
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.show(this.current + 1), {
        signal: this.abortController.signal,
      });

      this.dots.forEach((dot) => {
        dot.addEventListener(
          'click',
          () => {
            this.show(Number(dot.dataset.heroDot));
          },
          { signal: this.abortController.signal }
        );
      });

      this.show(0);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      window.clearInterval(this.autoplayTimer);
    }

    show(index) {
      if (!this.slides.length) return;

      this.current = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.current;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      this.startAutoplay();
    }

    startAutoplay() {
      window.clearInterval(this.autoplayTimer);

      if (this.dataset.autoplay !== 'true' || this.slides.length < 2) return;

      const interval = Number(this.dataset.interval) || 5000;
      this.autoplayTimer = window.setInterval(() => this.show(this.current + 1), interval);
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
